
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Text, ShowDateTime, TextLink, Button } from '@drawbotics/react-drylus';
import { Fragment } from 'react';
import Playground  from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Text`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Text } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Text>Text text</Text>`} component={Text} enums={{
      ShowDateTime
    }} mdxType="Playground">
  <Text mdxType="Text">Text text</Text>
</Playground>
<p>{`The component also accepts instances of itself and of `}<a parentName="p" {...{
        "href": "/components/TextLink"
      }}><inlineCode parentName="a">{`TextLink`}</inlineCode></a>{`:`}</p>
<Playground __position={1} __code={`<Text>I'm some text with <Text bold>bold</Text> text and a <TextLink>link</TextLink></Text>`} mdxType="Playground">
  <Text mdxType="Text">I'm some text with <Text bold mdxType="Text">bold</Text> text and a <TextLink mdxType="TextLink">link</TextLink></Text>
</Playground>
<h2>{`Auto format`}</h2>
<Playground __position={2} __code={`<Text locale="en">I bought a bread for {{ value: 1, currency: 'EUR' }} on the {new Date('04-20-2019')}</Text>`} mode="jsx" mdxType="Playground">
  <Text locale="en" mdxType="Text">I bought a bread for {{
          value: 1,
          currency: 'EUR'
        }} on the {new Date('04-20-2019')}</Text>
</Playground>
<h3>{`With Date`}</h3>
<p><inlineCode parentName="p">{`Text`}</inlineCode>{` is also a smart component in the sense that depending on the children passed to it, it will render them accordingly.
For example, if you pass an instance of `}<inlineCode parentName="p">{`Date`}</inlineCode>{`, the date will be formatted following the Drawbotics conventions using the current locale. You can modify the formatting through the `}<inlineCode parentName="p">{`dateOptions`}</inlineCode>{` prop.`}</p>
<Playground __position={3} __code={`<>
  <Text locale="en">This is a text with a date: {new Date()}</Text>
  <br/>
  <Text locale="fr">Ceci est du texte avec une date: {new Date()}</Text>
  <br/>
  <Text locale="nl">Blabla: {new Date()}</Text>
</>`} mode="jsx" mdxType="Playground">
  <>
    <Text locale="en" mdxType="Text">This is a text with a date: {new Date()}</Text>
    <br />
    <Text locale="fr" mdxType="Text">Ceci est du texte avec une date: {new Date()}</Text>
    <br />
    <Text locale="nl" mdxType="Text">Blabla: {new Date()}</Text>
  </>
</Playground>
<p>{`The internal function used for this is exposed as `}<inlineCode parentName="p">{`formatDate`}</inlineCode>{`, which you can import from the package. Formatting options are from `}<a parentName="p" {...{
        "href": "https://day.js.org/docs/en/display/format"
      }}>{`Day.js`}</a></p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { formatDate } from '@drawbotics/react-drylus';

// Usage
formatDate({
  date,                  // Javascript Date object
  options: dateOptions,  // { showTime: Enum, asArchive: boolean, format: Day.js options }
  locale,                // To override the automatically recognised locale
});
`}</code></pre>
<h3>{`With Currency`}</h3>
<p>{`It also accepts objects with the following shape:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  value: number,
  currency?: string,
}
`}</code></pre>
<p>{`And will render the price/value depending on the currency and current locale.`}</p>
<Playground __position={4} __code={`<>
  <Text locale="en">This is a text with a price: {{ value: 10000, currency: 'USD' }}</Text>
  <br/>
  <Text locale="fr">Ceci est du texte avec un prix: {{ value: 10000, currency: 'EUR' }}</Text>
  <br/>
  <Text locale="en">The number {{ value: 10000 }} is just a number</Text>
</>`} mode="jsx" mdxType="Playground">
  <>
    <Text locale="en" mdxType="Text">This is a text with a price: {{
            value: 10000,
            currency: 'USD'
          }}</Text>
    <br />
    <Text locale="fr" mdxType="Text">Ceci est du texte avec un prix: {{
            value: 10000,
            currency: 'EUR'
          }}</Text>
    <br />
    <Text locale="en" mdxType="Text">The number {{
            value: 10000
          }} is just a number</Text>
  </>
</Playground>
<p>{`The internal function used for this is exposed as `}<inlineCode parentName="p">{`formatPrice`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { formatPrice } from '@drawbotics/react-drylus';

// Usage
formatPrice({
  price,        // { currency: string, value: number }
  options,      // toLocaleString options
  locale,       // To override the automatically recognised locale
});
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;